import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-028ad527"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "workout-note" }

import { toRefs, withDefaults } from 'vue'

  interface Props {
    notes?: string | null
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    notes: { default: () => null }
  },
  setup(__props: any) {

const props = __props as { notes: string | null }

  

  const { notes } = toRefs(props)

return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('workouts.NOTES')), 1)
      ]),
      content: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(notes) && _unref(notes) !== '' ? _unref(notes) : _ctx.$t('workouts.NO_NOTES')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})